module.exports = __webpack_public_path__ + "img/2.1.4ed027ea.jpg";